// extracted by css-extract-rspack-plugin
export default {"dashboardTabs":"EiKTe","fullBleedBorder":"zRiFC","createTabButton":"_Dn1O"};